import { render, staticRenderFns } from "./OrderReview.vue?vue&type=template&id=7643db4e&"
import script from "./OrderReview.vue?vue&type=script&lang=js&"
export * from "./OrderReview.vue?vue&type=script&lang=js&"
import style0 from "./OrderReview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports